import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import detector from 'i18next-browser-languagedetector';
import {
  cond, anyPass, T, pipe, take, equals,
} from 'ramda';

import { EN, DE, DEFAULT_LANGUAGE } from '@/utils/consts';

const checkLanguage = () => {
  cond([
    [anyPass([equals(EN), equals(DE)]), T],
    [pipe(take(2), equals(EN)), () => i18n.changeLanguage(EN)],
    [pipe(take(2), equals(DE)), () => i18n.changeLanguage(DE)],
    [T, () => i18n.changeLanguage(DEFAULT_LANGUAGE)],
  ])(i18n.language);
};

if (typeof window !== 'undefined') {
  i18n
    .use(Backend)
    .use(detector)
    .use(initReactI18next)
    .init({
      fallbackLng: DEFAULT_LANGUAGE,
      load: 'languageOnly',
      debug: process.env.GATSBY_PROCESS === 'development',
      interpolation: {
        escapeValue: false,
      },
    }, checkLanguage);
}

i18n.setEn = () => i18n.changeLanguage(EN);
i18n.setDe = () => i18n.changeLanguage(DE);
i18n.isEn = () => i18n.language === EN;
i18n.isDe = () => i18n.language === DE;

export default i18n;
